import React, { useRef, useState, useEffect } from 'react';
import { useFirestore } from '../contexts/FirestoreContext';
import { Form, Button, Col, Row, FloatingLabel } from 'react-bootstrap';

function ReportingTypeForm({
  reportingType,
  onReportingTypeUpdated,
  onReportingTypeAdded,
  onModalClose,
  registerCleanup
}) {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { addData, updateData, queryData } = useFirestore();

  const factoryRef = useRef();
  const codeRef = useRef();
  const nameRef = useRef();

  useEffect(() => {
    if (reportingType) {
      factoryRef.current.value = reportingType.factory || '';
      codeRef.current.value = reportingType.code || '';
      nameRef.current.value = reportingType.name || '';
    }
  }, [reportingType]);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const factoryVal = factoryRef.current.value;
    const newCode = codeRef.current.value.trim();
    const data = {
      factory: factoryVal,
      code: newCode,
      name: nameRef.current.value.trim()
    };

    try {
      // 1. Fetch any docs with that code
      const existingByCode = await queryData('reportingTypes', 'code', '==', newCode);

      // 2. Filter to those with the same factory
      const duplicates = existingByCode.filter(
        doc => doc.factory === factoryVal
      );

      // 3. If editing, allow the one matching this id—otherwise any match is bad.
      if (
        duplicates.length > 1 ||
        (duplicates.length === 1 && duplicates[0].id !== reportingType?.id)
      ) {
        throw new Error('DUPLICATE_FACTORY_CODE');
      }

      // 4. Proceed to add or update
      if (reportingType) {
        await updateData('reportingTypes', reportingType.id, data);
        onReportingTypeUpdated?.(data);
      } else {
        await addData('reportingTypes', data);
        onReportingTypeAdded?.(data);
      }

      onModalClose?.();
    } catch (err) {
      if (err.message === 'DUPLICATE_FACTORY_CODE') {
        setError('That Factory + Code combination is already in use.');
      } else {
        console.error(err);
        setError('Failed to save reporting type');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-4" style={{ width: '100%', margin: '0 auto' }}>
      {error && <div className="alert alert-danger">{error}</div>}
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} md={4} className="mb-3">
            <FloatingLabel controlId="factorySelect" label="Factory">
              <Form.Select ref={factoryRef}>
                <option value="Ford">Ford</option>
                <option value="GM">GM</option>
              </Form.Select>
            </FloatingLabel>
          </Col>
          <Col xs={12} md={4} className="mb-3">
            <FloatingLabel controlId="codeInput" label="Code">
              <Form.Control type="text" ref={codeRef} />
            </FloatingLabel>
          </Col>
          <Col xs={12} md={4} className="mb-3">
            <FloatingLabel controlId="nameInput" label="Name">
              <Form.Control type="text" ref={nameRef} />
            </FloatingLabel>
          </Col>
        </Row>
        <Button variant="primary" type="submit" disabled={loading} className="mt-3">
          {reportingType ? 'Update' : 'Add'}
        </Button>
      </Form>
    </div>
  );
}

export default ReportingTypeForm;
